import React from 'react'

import { ColorTypes, colors } from './colors'
import noop from '../../helpers/noop'

type ButtonProps = {
  border?: boolean
  type?: 'success' | 'danger' | 'primary' | 'light' | 'info'
  color?: ColorTypes
  m?: '1'
  ml?: '2'
  size?: 'lg' | 'sm'
  onClick?: Function
  className?: string
  //TODO: remove any type
  children: any
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      m,
      ml,
      type,
      border,
      color = 'black',
      onClick = noop,
      children,
      size,
      className = '',
      ...rest
    },
    ref
  ) => {
    const classes = ['btn', className]
    if (border) classes.push('border')
    if (type) classes.push(`bg-${type}`)
    if (m) classes.push(`m-${m}`)
    if (ml) classes.push(`ml-${ml}`)
    if (size) classes.push(`btn-${size}`)

    return (
      <button
        {...rest}
        ref={ref}
        className={classes.join(' ')}
        onClick={() => onClick()}
        style={{ color: colors[color] }}
      >
        {children}
      </button>
    )
  }
)
